
import { Component, Mixins } from "vue-property-decorator";
import { formMixin, formOptionsMixin, formValidationMixin } from "../mixins";
import Select from "./Select.vue";
import { getModule } from "vuex-module-decorators";
import { SystemModule } from "@/store/modules";

const systemModule = getModule(SystemModule);

@Component({
  components: {
    Select
  }
})
export default class OrderStatusSelect extends Mixins(
  formMixin,
  formOptionsMixin,
  formValidationMixin
) {
  get options() {
    return systemModule.orderStatuses.map(x => ({ label: x.description, value: x.code }));
  }
}
